import { Component, Input, OnInit, inject } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import Utils from 'src/app/utils';

@Component({
  selector: 'app-form-input',
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.scss'],
  standalone: false,
})
export class FormInputComponent implements OnInit {
  i18n = inject(TranslateService);

  @Input() control: AbstractControl = new FormControl();
  @Input() label: string;
  @Input() placeholder: string;
  @Input() type = 'text';
  @Input() showError = false;

  ngOnInit() {}

  clear() {
    this.control.setValue('');
  }

  get errorMessage() {
    return Utils.getErrorMessage(this.control.errors, this.label, this.i18n);
  }
}
